// extracted by mini-css-extract-plugin
export default {"activity":"Activity_activity__C9Tdx","offset":"Activity_offset__kxwdQ"};